import { atom, selector } from 'recoil'
import * as turf from "@turf/turf"

import { selectedFocusAreaAtom } from "../../../map/selectedRegionAtoms"

export const TRAVEL_TIMES = Object.freeze([
  {
    value: 5 * 60,
    label: '5min',
  },
  {
    value: 10 * 60,
    label: '10min',
  },
  {
    value: 15 * 60,
    label: '15min',
  },
  {
    value: 20 * 60,
    label: '20min',
  },
  {
    value: 30 * 60,
    label: '30min',
  },
])

export const TRAVEL_TYPES = Object.freeze([
  {
    label: 'Walking',
    value: 'walking',
  	default: false,
  },
  {
    label: 'Cycling',
    value: 'cycling',
    default: false,
  },
  {
    label: 'Public transport',
    value: 'public_transport',
    default: true,
  },
  {
    label: 'Driving',
    value: 'driving',
  	default: false,
  },
])

const getNextWednesdayNoon = () => {
  const wednesday = 3
  const d = new Date()

  d.setUTCHours(12)
  d.setUTCMinutes(0)
  d.setUTCSeconds(0)
  d.setUTCMilliseconds(0)
  
  do {
    // Never today!
    d.setUTCDate(d.getUTCDate() + 1)
  } while (d.getDay() !== wednesday)

  return d
}

export const defaultOption = (options={}) => {
	return {
    app_id: null,
    api_key: null,
    travel_time: TRAVEL_TIMES[2].value,
    type: TRAVEL_TYPES[2].value,
    departure_time: getNextWednesdayNoon().toISOString(),
    ...options
  }
}

export const newTravelTimeDataCacheEntry = (options, data) => ({
	options,
	data,	
})

export const travelTimeLoadingAtom = atom({
  key: "travel-time-loading-atom",
  default: false
});

export const travelTimeRenderingAtom = atom({
  key: "travel-time-rendering-atom",
  default: false
});

export const travelTimeDataCacheAtom = atom({
  key: "travel-time-data-cache-atom",
 	default: newTravelTimeDataCacheEntry(null, null)
});

export const travelTimeOptionsAtom = atom({
  key: "travel-time-options-atom",
 	default: defaultOption()
});

export const travelTimeFocusPointModeAtom = atom({
  key: "travel-time-focus-point-mode-atom",
  default: false
});

export const travelTimeFocusPointAtom = atom({
  key: "travel-time-focus-point-atom",
  default: null // [lng, lat]
});

export const travelTimeFocusPointSelector = selector({
  key: "travel-time-focus-point-selector",
  get: ({ get }) => {
    const focusPoint = get(travelTimeFocusPointAtom)
    const selectedFocusArea = get(selectedFocusAreaAtom)

    if (focusPoint) {
      return focusPoint
    }

    if (selectedFocusArea) {
      const centroid = turf.centerOfMass(selectedFocusArea)
      return [
        centroid.geometry.coordinates[0],
        centroid.geometry.coordinates[1],
      ]
    }

    return null
  }
});

export const travelTimeOptionsSelector = selector({
  key: "travel-time-options-selector",
 	get: ({ get }) => {
 		const options = get(travelTimeOptionsAtom)
    const focusPoint = get(travelTimeFocusPointSelector)

 		if (!focusPoint) {
      return defaultOption(options)
    }

    return defaultOption({
      ...options,
      lng: focusPoint[0],
      lat: focusPoint[1],
    })
	},
});